import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { bool, func, shape, string } from 'prop-types'

import { SALUTATION_FIELD } from 'shared/consts/formFields'
import ErrorMessage from 'views/components/atoms/ErrorMessage'
import InputCheckboxOrRadio from 'views/components/molecules/InputCheckboxOrRadio'

import './Salutation.scss'

const Salutation = ({
  label,
  required,
  type,
  register,
  watch,
  errors,
  name,
  showDiverse,
  showUnspecified,
}) => {
  const typePrefix = type ? `${type}-` : ''
  return (
    <div className="u-margin--bottom o-Salutation__wrapper">
      {label && (
        <div className="u-margin-xx-small--bottom">
          <span className="a-label">
            <Trans id="general.form.label.salutation" />
            {required && '*'}
          </span>
        </div>
      )}
      <fieldset data-clientside-hook="formControlContainer">
        <ul className="l-flex l-flex--wrap a-list-reset o-Salutation__container">
          <li className="u-margin-x-large--right u-margin--top l-flex--shrink">
            <InputCheckboxOrRadio
              id={`${typePrefix}salutation_female`}
              type="radio"
              name={SALUTATION_FIELD}
              value="mrs"
              defaultChecked={watch ? watch(SALUTATION_FIELD) === 'mrs' : null}
              register={register}
              data-clientside-hook="formControlValidation"
              required={required && !label}
            >
              <Trans id="general.label.salutation.mrs" />
            </InputCheckboxOrRadio>
          </li>
          <li
            className={classNames('u-margin--top l-flex--shrink', {
              'u-margin-x-large--right': showDiverse || showUnspecified,
            })}
          >
            <InputCheckboxOrRadio
              id={`${typePrefix}salutation_male`}
              type="radio"
              name={SALUTATION_FIELD}
              value="mr"
              defaultChecked={watch ? watch(SALUTATION_FIELD) === 'mr' : null}
              register={register}
              data-clientside-hook="formControlValidation"
              required={required && !label}
            >
              <Trans id="general.label.salutation.mr" />
            </InputCheckboxOrRadio>
          </li>
          {showDiverse && (
            <li
              className={classNames('u-margin--top l-flex--shrink', {
                'u-margin-x-large--right': showUnspecified,
              })}
            >
              <InputCheckboxOrRadio
                id={`${typePrefix}salutation_diverse`}
                type="radio"
                name={SALUTATION_FIELD}
                value="diverse"
                defaultChecked={
                  watch ? watch(SALUTATION_FIELD) === 'diverse' : null
                }
                register={register}
                data-clientside-hook="formControlValidation"
                required={required && !label}
              >
                <Trans id="general.label.salutation.diverse" />
              </InputCheckboxOrRadio>
            </li>
          )}
          {showUnspecified && (
            <li className="u-margin--top l-flex--shrink u-margin-x-large--right">
              <InputCheckboxOrRadio
                id={`${typePrefix}salutation_unspecified`}
                type="radio"
                name={SALUTATION_FIELD}
                value="unspecified"
                defaultChecked={
                  watch ? watch(SALUTATION_FIELD) === 'unspecified' : null
                }
                register={register}
                data-clientside-hook="formControlValidation"
                required={required && !label}
              >
                <Trans id="general.label.salutation.unspecified" />
              </InputCheckboxOrRadio>
            </li>
          )}
        </ul>
        <ErrorMessage errors={errors} name={name} />
      </fieldset>
    </div>
  )
}
Salutation.propTypes = {
  label: bool,
  required: bool,
  type: string,
  register: func,
  watch: func,
  errors: shape({}),
  name: string,
  showDiverse: bool,
  showUnspecified: bool,
}

Salutation.defaultProps = {
  label: false,
  required: false,
  type: null,
  register: null,
  watch: null,
  errors: null,
  name: null,
  showDiverse: false,
  showUnspecified: false,
}

export default Salutation
